
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("g83UP"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("bjVRl", function(module, exports) {

var $9zUhf = parcelRequire("9zUhf");

var $1P1Tu = parcelRequire("1P1Tu");

const $d2a35dc366472da4$var$initialState = {
    portalContainerRef: null,
    autohighlightText: '',
    autohighlightContext: '',
    sessionId: '',
    autohighlightSelectionRect: {
        top: 0,
        left: 0,
        width: 0,
        height: 0
    },
    autohighlightHovered: false,
    showPopup: false,
    popupLoading: false,
    showSpotlight: false,
    existingMap: new Map(),
    lastAcronymReset: ()=>{},
    defineDefinitionOpen: false
};
const $d2a35dc366472da4$export$e324594224ef24da = {
    showAutohighlightPopup: ({ autohighlightText: autohighlightText, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, lastAcronymReset: lastAcronymReset, sessionId: sessionId })=>({ setState: setState })=>{
            setState({
                autohighlightText: autohighlightText,
                autohighlightContext: autohighlightContext,
                autohighlightSelectionRect: autohighlightSelectionRect,
                lastAcronymReset: lastAcronymReset,
                sessionId: sessionId,
                showPopup: true,
                popupLoading: true
            });
        },
    hideAutohighlightPopup: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                showPopup: false,
                popupLoading: false
            });
        },
    setDefineDefinitionOpen: ({ defineDefinitionOpen: defineDefinitionOpen })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                defineDefinitionOpen: defineDefinitionOpen
            });
        },
    setAutohighlightPopupLoaded: ()=>({ setState: setState, getState: getState })=>{
            getState().lastAcronymReset();
            setState({
                ...getState(),
                popupLoading: false
            });
        },
    setAutohighlightHovered: ({ autohighlightHovered: autohighlightHovered })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                autohighlightHovered: autohighlightHovered
            });
        },
    showAutohighlightSpotlight: ({ autohighlightSelectionRect: autohighlightSelectionRect })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                showSpotlight: true,
                autohighlightSelectionRect: autohighlightSelectionRect
            });
        },
    setPortalContainerRef: ({ portalContainerRef: portalContainerRef })=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                portalContainerRef: portalContainerRef
            });
        }
};
const $d2a35dc366472da4$export$f24428a461500521 = (0, $1P1Tu.createStore)({
    initialState: $d2a35dc366472da4$var$initialState,
    actions: $d2a35dc366472da4$export$e324594224ef24da,
    name: 'readingAidsStore'
});
const $d2a35dc366472da4$export$c6f45fcecbb3630d = (0, $9zUhf.createActionsHook)($d2a35dc366472da4$export$f24428a461500521);
const $d2a35dc366472da4$export$94639db5354ca53c = (0, $9zUhf.createStateHook)($d2a35dc366472da4$export$f24428a461500521);
module.exports["useReadingAidsActions"] = $d2a35dc366472da4$export$c6f45fcecbb3630d;
module.exports["useReadingAidsState"] = $d2a35dc366472da4$export$94639db5354ca53c;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("g83UP", function(module, exports) {

let $bbe06e44a25e530a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bbe06e44a25e530a$var$load("h3ABO"),
    $bbe06e44a25e530a$var$load("lTK3c"),
    $bbe06e44a25e530a$var$load("1WXdc"),
    $bbe06e44a25e530a$var$load("U4fwL"),
    $bbe06e44a25e530a$var$load("kaB35"),
    $bbe06e44a25e530a$var$load("cvmn7"),
    $bbe06e44a25e530a$var$load("jmFg4"),
    $bbe06e44a25e530a$var$load("6tWV0"),
    $bbe06e44a25e530a$var$load("2YffH"),
    $bbe06e44a25e530a$var$load("6wr18"),
    $bbe06e44a25e530a$var$load("6mHrv"),
    $bbe06e44a25e530a$var$load("awWN9"),
    $bbe06e44a25e530a$var$load("hdYRX"),
    $bbe06e44a25e530a$var$load("4wvcA"),
    $bbe06e44a25e530a$var$load("6qlX6"),
    $bbe06e44a25e530a$var$load("c28JM"),
    $bbe06e44a25e530a$var$load("50ame"),
    $bbe06e44a25e530a$var$load("hZtKG"),
    $bbe06e44a25e530a$var$load("kCvt5"),
    $bbe06e44a25e530a$var$load("lVO3w"),
    $bbe06e44a25e530a$var$load("hyzoX"),
    $bbe06e44a25e530a$var$load("9anPW"),
    $bbe06e44a25e530a$var$load("6r6j2"),
    $bbe06e44a25e530a$var$load("c7Kmx"),
    $bbe06e44a25e530a$var$load("eBRUf"),
    $bbe06e44a25e530a$var$load("im1VN"),
    $bbe06e44a25e530a$var$load("kUoOJ"),
    $bbe06e44a25e530a$var$load("8Skll"),
    $bbe06e44a25e530a$var$load("7gHIc"),
    $bbe06e44a25e530a$var$load("jLOHm"),
    $bbe06e44a25e530a$var$load("lk5YE"),
    $bbe06e44a25e530a$var$load("eZnzH"),
    $bbe06e44a25e530a$var$load("Wowvf"),
    $bbe06e44a25e530a$var$load("dbdNk"),
    $bbe06e44a25e530a$var$load("h5FT3"),
    $bbe06e44a25e530a$var$load("2KQ22"),
    $bbe06e44a25e530a$var$load("fth3E"),
    $bbe06e44a25e530a$var$load("3GuOt"),
    $bbe06e44a25e530a$var$load("3sb7M"),
    $bbe06e44a25e530a$var$load("5NQgH"),
    $bbe06e44a25e530a$var$load("daVOf"),
    $bbe06e44a25e530a$var$load("k3jER"),
    $bbe06e44a25e530a$var$load("9ldRJ"),
    $bbe06e44a25e530a$var$load("9wzNh"),
    $bbe06e44a25e530a$var$load("hv4mn"),
    $bbe06e44a25e530a$var$load("37ldp"),
    $bbe06e44a25e530a$var$load("hhss7"),
    $bbe06e44a25e530a$var$load("6iz6l"),
    $bbe06e44a25e530a$var$load("4SCW2"),
    $bbe06e44a25e530a$var$load("fdKpi"),
    $bbe06e44a25e530a$var$load("ffEVr"),
    $bbe06e44a25e530a$var$load("8YSo7"),
    $bbe06e44a25e530a$var$load("70hqB"),
    $bbe06e44a25e530a$var$load("f95iu"),
    $bbe06e44a25e530a$var$load("7k1ns"),
    $bbe06e44a25e530a$var$load("6bVVs"),
    $bbe06e44a25e530a$var$load("7mo6o"),
    $bbe06e44a25e530a$var$load("5GaTI"),
    $bbe06e44a25e530a$var$load("eTYdV"),
    $bbe06e44a25e530a$var$load("7EorR"),
    $bbe06e44a25e530a$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.1a54fec9.js.map
